import { render, staticRenderFns } from "./HeaderEditPartial.vue?vue&type=template&id=72b4b303&"
import script from "./HeaderEditPartial.vue?vue&type=script&lang=js&"
export * from "./HeaderEditPartial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../whitelabel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports